import { Component, Vue } from 'vue-property-decorator';
import WithRender from  './taura.html';
import config from "@/settings/config.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import _axios from '@/services/axios';
import moment from 'moment';
import { UserType } from '@/types/users.types';
import { ReInstateType } from './ReInstateType';
import { TauraResponseType } from './TauraResponseType';

@WithRender
@Component({
  filters:{
    formateDate(value: string)
    {
      return moment(value).format('YYYY-MM-DD HH:mm A')
    }
  },
  components: {
    Loading,
  },
})
export default class Taura extends Vue {
  voucher = "";
  busy = false;
  processing = false;
  reInstateType: ReInstateType = {} as ReInstateType;
  tauraResponse: TauraResponseType = {} as TauraResponseType;
  
  items = [];
  fields = [
    {
      key: "createdOn",
      label: "Created On",
    },
    {
      key: "updatedOn",
      label: "Redeemed On",
    },
    {
      key: "redeemedBy",
    },
    {
      key: "redeemed",
    },
    {
      key: "currency",
    },
    {
      key: "amount",
    },
    {
      key: "reInstatedOn",
      label: "Re-Instated On",
    },
    {
      key: "id",
      label:""
    }
  ]

  async onSearch() {
    try {
      this.busy = true;
      this.processing = true;
      const response = await _axios.get(`${config.gateway}ordernumbergenerator/v1/api/admin/Voucher/validate?voucher=${this.voucher}`);
      this.tauraResponse = response.data;
    } catch (error) {
        this.$bvToast.toast(error.response.data, {
            title: 'Notification',
            variant: 'danger',
            autoHideDelay: 5000,
        });
    }
    finally
    {
      this.busy = false;
      this.processing = false;
    }
  }

  
  onCancel() {
    this.busy = false;
    this.processing = false;
  };

  onOK() {
    this.processing = true;
    this.onReInstate();
  }

  async onReInstate() {
    try {
      this.reInstateType.voucher = this.voucher;
      await _axios.post(`${config.gateway}ordernumbergenerator/v1/api/admin/Voucher/re-instate`, this.reInstateType);
      this.$router.push("users");
    } catch (error) {
      this.$bvToast.toast(error.response.data, {
        title: 'Notification',
        variant: 'danger',
        autoHideDelay: 5000,
      });
    }
    finally
    {
      this.busy = false;
      this.processing = false;
    }
  }

}
